export const GET_LIST_NGUONVON = "GET_LIST_NGUONVON";
export const GET_LIST_NGUONVON_SUCCESS = "GET_LIST_NGUONVON_SUCCESS";
export const GET_LIST_NGUONVON_FAILURE = "GET_LIST_NGUONVON_FAILURE";

export const UPDATE_SEARCHTDATA_NGUONVON = "UPDATE_SEARCHTDATA_NGUONVON";
